// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

:root {
  height: 100%;
  width: 100%;
  background: rgb(36, 36, 36);
  background: linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#242424", endColorstr="#2d2d2d", GradientType=1);
}

video {
  position: absolute;
  width: auto;
  height: 100vh;
  z-index: -1;
}


.typewriter span {
  color: #48cae4;
}

.typewriter {
  position: absolute;
  z-index: 1;
}

.typewriter p {
  margin-top: 40vh;
  margin-left: 10vw;
}


.typewriter button {
  position: absolute;
  z-index: 1;
  margin-left: 15vw;
  background-color: none;
  color: white;
  padding: 10px;
  font-family: 'Bebas Neue', cursive;
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(9, 166, 228, 0.4);
  /* Black w/ opacity */
}

.typewriter button:hover {
  text-decoration: underline;
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(9, 166, 228, 0.8);
  /* Black w/ opacity */
}

.typewriter p {
  border-right: solid 3px rgba(0, 255, 0, .75);
  white-space: nowrap;
  overflow: hidden;
  font-family: 'Bebas Neue', cursive;
  font-size: 3rem;
  color: rgba(255, 255, 255, .70);
}

.modal-dialog {
  position: absolute;
  z-index: 1;
  max-width: 90vw;
}

.modal-header {
  background-color: #2b2d42;
  color: white;
  border-bottom: 1px solid #e5e5e5;
}

.modal-body {
  background-color: #2b2d42;
  color: white;
}

.modal-footer {
  background-color: #2b2d42;
  color: white;
}

nav {
  box-shadow: 0 1em 1em -1em rgba(0, 0, 0, .45);
}

.navbar a {
  color: white !important;
  text-decoration: none !important;
  padding: 0 !important;
}

.navbar a:hover {
  background-color: #3e454c;
}

.navbar .selected {
  color: white;
  text-decoration: underline;
}

.nav-item {
  margin-top: 0;
  padding: 0;
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
}

.linkText {
  font-size: 20px;
  font-weight: 100;
  color: rgb(184, 184, 184);
}

.nav-item img {
  height: 30px;

}

/* Animation */
.typewriter p {
  animation: animated-text 2s steps(29, end) 1s 1 normal both,
    animated-cursor 600ms steps(29, end) infinite;
}

.svg {
  margin-left: 60vw;
  margin-top: 10vh;
  position: absolute;
}

#chart {
  animation: moveitem 1s 1;
}

#Desk {
  animation: moveitem 2s 1;
}

#Chair {
  animation: moveitem 3s 1;
}

#person {
  animation: moveitem 3s 1;
}

@keyframes moveitem {
  from {
    transform: translateX(100vw);
  }

  to {
    transform: translateX(10px);
  }
}


/* text animation */

@keyframes animated-text {
  from {
    width: 0;
  }

  to {
    width: 730px;
  }
}

/* cursor animations */

@keyframes animated-cursor {
  from {
    border-right-color: rgba(0, 255, 0, .75);
  }

  to {
    border-right-color: transparent;
  }
}


@media (min-aspect-ratio: 16/9) {
  video {
    width: 100%;
    height: auto;
  }
}

@media (max-aspect-ratio: 16/9) {
  video {
    width: auto;
    height: 100%;
  }
}

@media (max-width: 1400px) {
  .svg {
    display: none;
  }
}

@media (max-width: 850px) {
  .linkText {
    display: inline-block;
  }

  video {
    width: 90vw;
    height: 90vh;
    visibility: hidden;
  }

  body {
    background-color: grey;
    background-size: cover;
  }

  .typewriter p {
    border-right: solid 3px rgba(0, 255, 0, .75);
    white-space: nowrap;
    overflow: hidden;
    font-family: 'Bebas Neue', cursive;
    font-size: 25px;
    color: rgba(255, 255, 255, .90);
  }

  .typewriter p {
    margin-top: 40vh;
    margin-left: 5vw;
  }

  .typewriter button {
    margin-left: 5vw;
  }

  @keyframes animated-text {
    from {
      width: 0;
    }

    to {
      width: 320px;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAG3B,oFAAoF;EACpF,kHAAkH;AACpH;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;AACb;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;;AAEd;;AAEA,cAAc;AACd;EACE;iDAC+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;;AAGA,mBAAmB;;AAEnB;EACE;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,sBAAsB;;AAEtB;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,+BAA+B;EACjC;AACF;;;AAGA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,QAAQ;IACV;;IAEA;MACE,YAAY;IACd;EACF;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  height: 100%;\n  width: 100%;\n  background: rgb(36, 36, 36);\n  background: -moz-linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\n  background: -webkit-linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\n  background: linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#242424\", endColorstr=\"#2d2d2d\", GradientType=1);\n}\n\nvideo {\n  position: absolute;\n  width: auto;\n  height: 100vh;\n  z-index: -1;\n}\n\n\n.typewriter span {\n  color: #48cae4;\n}\n\n.typewriter {\n  position: absolute;\n  z-index: 1;\n}\n\n.typewriter p {\n  margin-top: 40vh;\n  margin-left: 10vw;\n}\n\n\n.typewriter button {\n  position: absolute;\n  z-index: 1;\n  margin-left: 15vw;\n  background-color: none;\n  color: white;\n  padding: 10px;\n  font-family: 'Bebas Neue', cursive;\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(9, 166, 228, 0.4);\n  /* Black w/ opacity */\n}\n\n.typewriter button:hover {\n  text-decoration: underline;\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(9, 166, 228, 0.8);\n  /* Black w/ opacity */\n}\n\n.typewriter p {\n  border-right: solid 3px rgba(0, 255, 0, .75);\n  white-space: nowrap;\n  overflow: hidden;\n  font-family: 'Bebas Neue', cursive;\n  font-size: 3rem;\n  color: rgba(255, 255, 255, .70);\n}\n\n.modal-dialog {\n  position: absolute;\n  z-index: 1;\n  max-width: 90vw;\n}\n\n.modal-header {\n  background-color: #2b2d42;\n  color: white;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.modal-body {\n  background-color: #2b2d42;\n  color: white;\n}\n\n.modal-footer {\n  background-color: #2b2d42;\n  color: white;\n}\n\nnav {\n  box-shadow: 0 1em 1em -1em rgba(0, 0, 0, .45);\n}\n\n.navbar a {\n  color: white !important;\n  text-decoration: none !important;\n  padding: 0 !important;\n}\n\n.navbar a:hover {\n  background-color: #3e454c;\n}\n\n.navbar .selected {\n  color: white;\n  text-decoration: underline;\n}\n\n.nav-item {\n  margin-top: 0;\n  padding: 0;\n  margin-left: 20px;\n  margin-right: 20px;\n  text-align: center;\n}\n\n.linkText {\n  font-size: 20px;\n  font-weight: 100;\n  color: rgb(184, 184, 184);\n}\n\n.nav-item img {\n  height: 30px;\n\n}\n\n/* Animation */\n.typewriter p {\n  animation: animated-text 2s steps(29, end) 1s 1 normal both,\n    animated-cursor 600ms steps(29, end) infinite;\n}\n\n.svg {\n  margin-left: 60vw;\n  margin-top: 10vh;\n  position: absolute;\n}\n\n#chart {\n  animation: moveitem 1s 1;\n}\n\n#Desk {\n  animation: moveitem 2s 1;\n}\n\n#Chair {\n  animation: moveitem 3s 1;\n}\n\n#person {\n  animation: moveitem 3s 1;\n}\n\n@keyframes moveitem {\n  from {\n    transform: translateX(100vw);\n  }\n\n  to {\n    transform: translateX(10px);\n  }\n}\n\n\n/* text animation */\n\n@keyframes animated-text {\n  from {\n    width: 0;\n  }\n\n  to {\n    width: 730px;\n  }\n}\n\n/* cursor animations */\n\n@keyframes animated-cursor {\n  from {\n    border-right-color: rgba(0, 255, 0, .75);\n  }\n\n  to {\n    border-right-color: transparent;\n  }\n}\n\n\n@media (min-aspect-ratio: 16/9) {\n  video {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-aspect-ratio: 16/9) {\n  video {\n    width: auto;\n    height: 100%;\n  }\n}\n\n@media (max-width: 1400px) {\n  .svg {\n    display: none;\n  }\n}\n\n@media (max-width: 850px) {\n  .linkText {\n    display: inline-block;\n  }\n\n  video {\n    width: 90vw;\n    height: 90vh;\n    visibility: hidden;\n  }\n\n  body {\n    background-color: grey;\n    background-size: cover;\n  }\n\n  .typewriter p {\n    border-right: solid 3px rgba(0, 255, 0, .75);\n    white-space: nowrap;\n    overflow: hidden;\n    font-family: 'Bebas Neue', cursive;\n    font-size: 25px;\n    color: rgba(255, 255, 255, .90);\n  }\n\n  .typewriter p {\n    margin-top: 40vh;\n    margin-left: 5vw;\n  }\n\n  .typewriter button {\n    margin-left: 5vw;\n  }\n\n  @keyframes animated-text {\n    from {\n      width: 0;\n    }\n\n    to {\n      width: 320px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
